import { Injectable } from '@angular/core';
import { Analytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';

@Injectable({
  providedIn: 'root',
})
export class AngularFireAnalytics {
  constructor(private readonly analytics: Analytics) {}

  setAnalyticsCollectionEnabled(enabled: boolean): void {
    setAnalyticsCollectionEnabled(this.analytics, enabled);
  }
}
